import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { publicApi } from '../services/api';
import logo from '../images/american_pub_poker.jpg';
import './Home.css';

const DAYS = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];

function Schedule() {
  const [games, setGames] = useState([]);
  const [venues, setVenues] = useState([]);
  const [tab, setTab] = useState('games');
  const [dayFilter, setDayFilter] = useState(new Date().getDay());
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = async () => {
    try {
      const [scheduleRes, venuesRes] = await Promise.all([
        publicApi.getSchedule(),
        publicApi.getVenues(),
      ]);
      setGames(scheduleRes.data?.games || []);
      setVenues(venuesRes.data?.venues || []);
    } catch (e) {
      console.error(e);
    } finally {
      setLoading(false);
    }
  };

  const dayGames = games.filter(g => new Date(g.startTime).getDay() === dayFilter);
  const formatTime = (d) => new Date(d).toLocaleTimeString('en-US', { hour: 'numeric', minute: '2-digit' });

  return (
    <div className="apk-home">
      <nav className="apk-nav">
        <div className="apk-nav-inner">
          <Link to="/home" className="apk-brand" style={{ textDecoration: 'none', color: '#fff' }}>
            <img src={logo} alt="American Pub Poker" />
            <span>American Pub Poker</span>
          </Link>
          <div className="apk-nav-links">
            <Link to="/home">Home</Link>
            <Link to="/" className="apk-nav-cta">Admin Login</Link>
          </div>
        </div>
      </nav>

      <section style={{ maxWidth: 1400, margin: '0 auto', padding: '60px 32px' }}>
        <div className="apk-section-header">
          <h2>Schedule & Venues</h2>
        </div>

        {/* Tabs */}
        <div style={{ display: 'flex', gap: 8, marginBottom: 32, borderBottom: '1px solid rgba(255,255,255,0.08)' }}>
          <button
            onClick={() => setTab('games')}
            style={{
              background: 'none',
              border: 'none',
              color: tab === 'games' ? '#d4a843' : 'rgba(255,255,255,0.5)',
              padding: '16px 24px',
              fontSize: 16,
              fontWeight: 700,
              cursor: 'pointer',
              borderBottom: tab === 'games' ? '2px solid #d4a843' : '2px solid transparent',
            }}
          >Games</button>
          <button
            onClick={() => setTab('venues')}
            style={{
              background: 'none',
              border: 'none',
              color: tab === 'venues' ? '#d4a843' : 'rgba(255,255,255,0.5)',
              padding: '16px 24px',
              fontSize: 16,
              fontWeight: 700,
              cursor: 'pointer',
              borderBottom: tab === 'venues' ? '2px solid #d4a843' : '2px solid transparent',
            }}
          >Venues</button>
        </div>

        {tab === 'games' && (
          <>
            {/* Day filter */}
            <div style={{ display: 'flex', gap: 8, marginBottom: 32, flexWrap: 'wrap' }}>
              {DAYS.map((day, i) => (
                <button
                  key={day}
                  onClick={() => setDayFilter(i)}
                  style={{
                    padding: '12px 20px',
                    borderRadius: 8,
                    border: '1px solid rgba(255,255,255,0.15)',
                    background: dayFilter === i ? '#d4a843' : 'rgba(255,255,255,0.04)',
                    color: dayFilter === i ? '#0a1628' : '#fff',
                    fontWeight: 700,
                    fontSize: 13,
                    cursor: 'pointer',
                    textTransform: 'uppercase',
                    letterSpacing: '0.05em',
                  }}
                >{day.slice(0, 3)}</button>
              ))}
            </div>

            {loading ? (
              <p className="apk-loading">Loading...</p>
            ) : dayGames.length === 0 ? (
              <p className="apk-empty">No games scheduled for {DAYS[dayFilter]}</p>
            ) : (
              <div className="apk-game-grid">
                {dayGames.map(g => (
                  <div key={g.id} className="apk-game-card">
                    <div className="apk-game-time">{formatTime(g.startTime)}</div>
                    <div className="apk-game-venue">{g.venue.name}</div>
                    <div className="apk-game-type">{g.gameType}</div>
                    {g.leagueName && <div className="apk-game-league">{g.leagueName}</div>}
                  </div>
                ))}
              </div>
            )}
          </>
        )}

        {tab === 'venues' && (
          <div className="apk-venue-grid">
            {venues.map(v => (
              <div key={v.id} className="apk-venue-card">
                <div className="apk-venue-name">{v.name}</div>
                {v.address && <div className="apk-venue-address">{v.address}</div>}
                {v.phone && <div className="apk-venue-address">📞 {v.phone}</div>}
                {v.hoursText && <div className="apk-venue-address">🕐 {v.hoursText}</div>}
                {v.rating && (
                  <div className="apk-venue-rating">
                    ⭐ {v.rating} {v.ratingCount > 0 && <span>({v.ratingCount})</span>}
                  </div>
                )}
                {v.description && (
                  <div style={{ fontSize: 13, color: 'rgba(255,255,255,0.6)', marginTop: 12 }}>
                    {v.description}
                  </div>
                )}
                {(v.amenities || []).length > 0 && (
                  <div style={{ display: 'flex', flexWrap: 'wrap', gap: 6, marginTop: 12 }}>
                    {v.amenities.map(a => (
                      <span key={a} style={{
                        background: 'rgba(212,168,67,0.1)',
                        color: '#d4a843',
                        padding: '4px 10px',
                        borderRadius: 12,
                        fontSize: 11,
                        fontWeight: 600,
                      }}>{a}</span>
                    ))}
                  </div>
                )}
              </div>
            ))}
          </div>
        )}
      </section>
    </div>
  );
}

export default Schedule;
